export default __webpack_public_path__ + "static/media/deliveryBoy.8744b31c.jpg";